import nodeApi from '../utils/nodeApiClient';

const contactsApi = {
  list: (params) => nodeApi.get('/contacts', { params }),
  getById: (id) => nodeApi.get(`/contacts/${id}`),
  create: (data) => nodeApi.post('/contacts', data),
  update: (id, data) => nodeApi.put(`/contacts/${id}`, data),
  remove: (id) => nodeApi.delete(`/contacts/${id}`),
  toggleStatus: (id) => nodeApi.patch(`/contacts/${id}/status`),

  getSalutations: () => nodeApi.get('/contacts/dropdowns/salutations'),
  getCountries: () => nodeApi.get('/contacts/dropdowns/countries'),
  getStates: (countryId) => nodeApi.get('/contacts/dropdowns/states', { params: { country_id: countryId } }),

  getPersons: (contactId) => nodeApi.get(`/contacts/${contactId}/persons`),
  createPerson: (contactId, data) => nodeApi.post(`/contacts/${contactId}/persons`, data),
  updatePerson: (cpId, data) => nodeApi.put(`/contacts/persons/${cpId}`, data),
  removePerson: (cpId) => nodeApi.delete(`/contacts/persons/${cpId}`),
  // Contact-scoped variants: the backend verifies the person belongs to contactId.
  createPersons: (contactId, persons) => nodeApi.post(`/contacts/${contactId}/persons`, { contact_persons: persons }),
  updateContactPerson: (contactId, cpId, data) => nodeApi.put(`/contacts/${contactId}/persons/${cpId}`, data),
  softDeleteContactPerson: (contactId, cpId) => nodeApi.delete(`/contacts/${contactId}/persons/${cpId}`)
};

export default contactsApi;
